import React, { FC } from 'react';
import { LawyerHeaderActions } from './LawyerHeaderActions';
import { LawyerHeaderSummary } from './LawyerHeaderSummary';
import { LawyerHeaderTop } from './lawyer-header-top/LawyerHeaderTop';
import { EntityCardHeader } from '../../../entity/components/EntityCardComponents';

type Props = {
  isFollowButtonPresent: boolean;
};

export const LawyerHeader: FC<Props> = ({ isFollowButtonPresent }) => (
  <EntityCardHeader id="lawyer-profile">
    <LawyerHeaderTop />
    <LawyerHeaderActions isFollowButtonPresent={isFollowButtonPresent} />
    <LawyerHeaderSummary />
  </EntityCardHeader>
);
